import { ProductionBaseChip } from "./ProductionBaseChip";
import type { ProductionBaseChipProps } from "./ProductionBaseChip.types";
import { useProductionBaseSettingsLink } from "./useProductionBaseSettingsLink";

/** The chip for the open project, linked to its settings page and its user's access. */
export const ProjectProductionBaseChip = (
  props: Omit<ProductionBaseChipProps, "settingsHref" | "canEdit">
) => {
  const { settingsHref, canEdit } = useProductionBaseSettingsLink();
  return <ProductionBaseChip {...props} settingsHref={settingsHref} canEdit={canEdit} />;
};
